import React from 'react';
import './OptionCard.css';

interface OptionCardProps {
  headline: string;
  text: string;
  buttonText: string;
  icon: React.ElementType;
  onButtonClick: () => void;
}

const OptionCard: React.FC<OptionCardProps> = ({
  headline,
  text,
  buttonText,
  icon: Icon,
  onButtonClick
}) => {
  return (
    <div className="option-card">
      <div className="option-card-content">
        <div className="option-card-left">
          <h2 className="option-card-headline">{headline}</h2>
          <p className="option-card-text">{text}</p>
          <button 
            className="option-card-button"
            onClick={onButtonClick}
          >
            {buttonText}
          </button>
        </div>
        <div className="option-card-right">
          <div className="option-card-image">
            <Icon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptionCard;
